export const VERY_USEFUL_LINKS = [
  { text: 'Договор оферты', to: '/docs/offer.pdf' },
  { text: 'Условия оказания услуг', to: '/docs/rules.pdf' },
  { text: 'Политика конфиденциальности', to: '/docs/policy.pdf' },
  { text: 'API', to: '/docs/API.md', target: '_blank' },
];

export const SERVICES_DETAILS = [
  { title: 'ИНН', text: '780632809205' },
  { title: 'ОГРН', text: '322470400124276' },
  { title: 'Дата регистрации', text: '29.12.2022' },
];

export const CONTACTS = [
  { title: 'Телеграмм', text: '@Boostclickru', to: `${process.env.REACT_APP_SUPPORT_ADDRESS}`, target: '_blank' },
  { title: 'Сайт компании', text: 'https://boostclick.ru/', to: 'https://boostclick.ru/', target: '_blank' },
];

export const BANK_DETAILS = [
  { title: 'ОКВЭД', text: '47.91' },
  { title: 'БИК', text: '044030723' },
  { title: 'Кор. счет', text: '30101810100000000723' },
  { title: 'Расч. счет', text: '40802810803000058306' },
];
